import React from "react";
import PageHeaderContent from "../../components/pageHeaderContent";

import ImageOne from "../../images/image1.png";
import ImageTwo from "../../images/image2.png";
import ImageThree from "../../images/image3.png";
import ImageFour from "../../images/image4.png";
import ImageFive from "../../images/image5.png";
import ImageSix from "../../images/image6.png";

import "./styles.scss";
import { useState } from "react";

const portfolioData = [
  {
    id: 1,
    name: "ShivDarshan Enterprises",
    image: ImageOne,
    link: "https://shivdarshanenterprises.com/",
  },
  {
    id: 5,
    name: "Quest - a Q&A  platform",
    image: ImageFive,

    link: "https://quest-client.netlify.app/",
  },
  {
    id: 2,
    name: "CinPlay",
    link: "https://hotstar-clone-19612.firebaseapp.com/",
    image: ImageTwo,
  },
 
  {
    id: 4,
    name: "zee-shopping Admin Pannel",
    image: ImageFour,

    link: "",
  },
 
  {
    id: 6,
    name: "SmartDine -AI based Food review System",
    image: ImageSix,

    link: "https://emotion-1aa3f.web.app/",
  },
  {
    id: 3,
    name: "Shoewala",
    image: ImageThree,
    link: "https://shoewala-c4b4c.web.app/",
  },
];

const Portfolio = () => {
  const [hoveredValue, setHoveredValue] = useState(null);

  function handleHover(index) {
    setHoveredValue(index);
  }

  // console.log("====================================");
  // console.log(hoveredValue);
  // console.log("====================================");

  return (
    <section id="portfolio" className="portfolio">
      <PageHeaderContent
        headerText="My Portfolio"
        
      />
      <div className="portfolio__content">
        <div className="portfolio__content__cards">
          {portfolioData.map((item, index) => (
            <div
              className="portfolio__content__cards__item"
              key={`cardItem${item.name.trim()}`}
              onMouseEnter={() => handleHover(index)}
            >
              <div className="portfolio__content__cards__item__img-wrapper">
                <a>
                  <img alt="dummy data" src={item.image} />
                </a>
              </div>
              <div className="overlay">
                {index === hoveredValue && (
                  <div>
                    <p>{item.name}</p>
                    <a href={item.link}>
                      <button>Visit</button>
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Portfolio;
